import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog', 'form', 'message', 'accountIdField', 'artworkIdField']

  open ({ params }) {
    this.accountIdFieldTarget.value = params.accountId
    this.artworkIdFieldTarget.value = params.artworkId

    this.dialogTarget.showModal()

    if (this.formTarget.querySelector('#inquiry_from_first_name').value) {
      this.formTarget.querySelector('#inquiry_from_phone').focus()
    } else {
      this.formTarget.querySelector('#inquiry_from_first_name').focus()
    }
  }

  close () {
    this.dialogTarget.close()
  }

  report (event) {
    if (event.detail.success) {
      this.showMessage('Submitted')
      setTimeout(() => this.close(), 500)
    } else {
      this.showMessage("We're sorry, an error has occured. Please try again.")
      setTimeout(() => this.close(), 3000)
    }
  }

  showMessage (message) {
    this.messageTarget.innerHTML = message
    this.messageTarget.classList.add('!block')
  }

  resetFields () {
    this.formTarget.reset()
    this.accountIdFieldTarget.value = null
    this.artworkIdFieldTarget.value = null
    this.messageTarget.innerHTML = ''
    this.messageTarget.classList.remove('!block')
  }
}
